import React, { useCallback } from 'react';
import { getEnvironmentConfig } from '../../environmentConfig';
import { Button } from '@/components/ui/button';
import { useIntegrationAuthorizationApi } from '../../api/useIntegrationAuthorizationApi';
import type { GlueIntegration } from '@glueapp/graph-types';

interface Props {
    integration: GlueIntegration<any>;
    label: string;
}

export const OAuthIntegrationAuthForm: React.FC<Props> = ({ integration, label }) => {
    const { startAuthorization } = useIntegrationAuthorizationApi();

    const authorizationOAuthFlow = useCallback(() => {
        let aborted = false;
        async function runFlow() {
            const { authorizationAttemptId } = await startAuthorization();
            if (!aborted) {
                window.location.href = `${getEnvironmentConfig().integrationServiceUrl}/authorize-integration/run/${
                    integration.provider
                }/${authorizationAttemptId}`;
            }
        }
        runFlow();
        return () => {
            aborted = true;
        };
    }, [startAuthorization, integration]);

    return <Button onClick={authorizationOAuthFlow}>{label}</Button>;
};
